import { ReactElement } from 'react';
import { Route } from 'react-router';
import { JOB_TYPE } from '../../../modules/jobs/jobs.model';
import { SwitchWithNotFound } from '../../containers/SwitchWithNotFound';
import { JobNotFoundView } from '../../views/errors/JobNotFound.view';
import { NotFoundView } from '../../views/errors/NotFound.view';
import { InferenceDetailsCreateView, InferenceDetailsView } from '../../views/home/inferenceDetails/InferenceDetails.view';
import { InferenceDetailsPredictionInspectorView } from '../../views/home/inferenceDetails/InferenceDetailsPredictionInspector.view';
import { InferencesView } from '../../views/home/Inferences.view';
import { Home } from '../config/Home';

export const InferencesRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.Inferences.List.Path}>
      <InferencesView />
    </Route>
    <Route path={Home.Inferences.NotFound.Path}>
      <JobNotFoundView jobType={JOB_TYPE.INFERENCE} />
    </Route>
    <Route path={Home.Inferences.Create.Path}>
      <InferenceDetailsCreateView />
    </Route>
    <Route path={Home.Inferences.Details.PredictionInspector.Path}>
      <InferenceDetailsPredictionInspectorView />
    </Route>
    <Route path={Home.Inferences.Details.Path}>
      <InferenceDetailsView />
    </Route>
  </SwitchWithNotFound>
);
